import type { EventType } from '@adgf/shared';

export interface AnalyticsConfig {
  endpoint: string;
  batchSize: number;
  flushIntervalMs: number;
  enabled: boolean;
  debug: boolean;
}

export interface TrackEventOptions {
  gameId?: string | null;
  data?: Record<string, unknown>;
  timestamp?: string;
}

export interface QueuedEvent {
  anonymous_user_id: string;
  game_id: string | null;
  session_id: string;
  event_type: EventType;
  event_data: Record<string, unknown>;
  timestamp: string;
}

export interface FlushResult {
  sent: number;
  failed: number;
  errors?: Error[];
}

export const DEFAULT_ANALYTICS_CONFIG: AnalyticsConfig = {
  endpoint: '/api/v1/events/batch',
  batchSize: 20,
  flushIntervalMs: 5000,
  enabled: true,
  debug: false,
};
